import createIcon from '../../createIcon';

/**
 * @component @name WbSunny
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi43NiA1LjM0MDc4TDQuOTYgMy41NTA3OEwzLjU1IDQuOTYwNzhMNS4zNCA2Ljc1MDc4TDYuNzYgNS4zNDA3OFpNNCAxMS4wMDA4SDFWMTMuMDAwOEg0VjExLjAwMDhaTTEzIDEuMDUwNzhIMTFWNC4wMDA3OEgxM1YxLjA1MDc4Wk0yMC40NSA0Ljk2MDc4TDE5LjA0IDMuNTUwNzhMMTcuMjUgNS4zNDA3OEwxOC42NiA2Ljc1MDc4TDIwLjQ1IDQuOTYwNzhaTTE3LjI0IDE4LjY2MDhMMTkuMDMgMjAuNDYwOEwyMC40NCAxOS4wNTA4TDE4LjY0IDE3LjI2MDhMMTcuMjQgMTguNjYwOFpNMjAgMTEuMDAwOFYxMy4wMDA4SDIzVjExLjAwMDhIMjBaTTEyIDYuMDAwNzhDOC42OSA2LjAwMDc4IDYgOC42OTA3OCA2IDEyLjAwMDhDNiAxNS4zMTA4IDguNjkgMTguMDAwOCAxMiAxOC4wMDA4QzE1LjMxIDE4LjAwMDggMTggMTUuMzEwOCAxOCAxMi4wMDA4QzE4IDguNjkwNzggMTUuMzEgNi4wMDA3OCAxMiA2LjAwMDc4Wk0xMSAyMi45NTA4SDEzVjIwLjAwMDhIMTFWMjIuOTUwOFpNMy41NSAxOS4wNDA4TDQuOTYgMjAuNDUwOEw2Ljc1IDE4LjY1MDhMNS4zNCAxNy4yNDA4TDMuNTUgMTkuMDQwOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbSunny = createIcon('WbSunny', [
  [
    'path',
    {
      d: 'M6.76 5.34078L4.96 3.55078L3.55 4.96078L5.34 6.75078L6.76 5.34078ZM4 11.0008H1V13.0008H4V11.0008ZM13 1.05078H11V4.00078H13V1.05078ZM20.45 4.96078L19.04 3.55078L17.25 5.34078L18.66 6.75078L20.45 4.96078ZM17.24 18.6608L19.03 20.4608L20.44 19.0508L18.64 17.2608L17.24 18.6608ZM20 11.0008V13.0008H23V11.0008H20ZM12 6.00078C8.69 6.00078 6 8.69078 6 12.0008C6 15.3108 8.69 18.0008 12 18.0008C15.31 18.0008 18 15.3108 18 12.0008C18 8.69078 15.31 6.00078 12 6.00078ZM11 22.9508H13V20.0008H11V22.9508ZM3.55 19.0408L4.96 20.4508L6.75 18.6508L5.34 17.2408L3.55 19.0408Z',
      key: 'vmgaf1',
    },
  ],
]);

export default WbSunny;
